import { __read } from "tslib";
import { useCallback, useEffect, useState, } from 'react';
import { format as dateFnsFormat, formatISO as dateFnsFormatISO, isValid as dateFnsIsValid, } from 'date-fns';
import { useControlled } from '../../utils/hooks/useControlled';
import { getStartOfDayByValue } from './utils';
import { TranslationKey } from '../../translation/TranslationKey';
import { validateDate } from './validateDate';
import { useVelocityPrivateContext } from '../../contexts/VelocityPrivateContext/VelocityPrivateContext';
export function useDatePickerState(_a) {
    var valueProp = _a.value, defaultValueProp = _a.defaultValue, onChange = _a.onChange, name = _a.name, disableFuture = _a.disableFuture, disablePast = _a.disablePast, disableWeekend = _a.disableWeekend, maxDate = _a.maxDate, minDate = _a.minDate, shouldDisableDate = _a.shouldDisableDate, _b = _a.initialOpen, initialOpen = _b === void 0 ? false : _b, format = _a.format;
    var translate = useVelocityPrivateContext().translate;
    var _c = __read(useState(initialOpen), 2), calendarOpen = _c[0], setCalendarOpen = _c[1];
    var _d = __read(useControlled({
        controlled: valueProp,
        default: defaultValueProp || null,
        name: 'DatePicker',
        state: 'value',
    }), 2), value = _d[0], setValue = _d[1];
    var date = getStartOfDayByValue(value, 'value');
    /*
          There is something off here:
          - Prop change with invalid date will leave the input value the same,
            so potentially showing a valid older date, and the actual date is invalid
            from external change.
            But, we cannot compare old and new dates, because date-fns uses vanilla Date, which doesn't give us
            the string value (only "Invalid date"), so we cannot compare old & new invalid "date".
            Unless we work with string value only....?
       */
    var _e = __read(useState(date && dateFnsIsValid(date)
        ? dateFnsFormat(date, format)
        : value
            ? translate(TranslationKey.DATE_PICKER_INVALID_INPUT_VALUE)
            : ''), 2), inputValue = _e[0], setInputValue = _e[1];
    useEffect(function () {
        if (date && dateFnsIsValid(date)) {
            // will not trigger anything if value is the same.
            // (so prop coming in as result from onChange)
            setInputValue(dateFnsFormat(date, format));
        }
    }, [date, format]);
    var changeHandler = useCallback(function (_a) {
        var newDate = _a.newDate, newInputValue = _a.newInputValue;
        var error = validateDate({
            date: newDate,
            value: newInputValue,
            options: {
                disablePast: disablePast,
                disableFuture: disableFuture,
                disableWeekend: disableWeekend,
                maxDate: maxDate,
                minDate: minDate,
                shouldDisableDate: shouldDisableDate,
            },
        });
        setValue(newDate);
        setInputValue(newInputValue);
        var localIsoString = newDate && dateFnsIsValid(newDate) ? dateFnsFormatISO(newDate) : '';
        onChange === null || onChange === void 0 ? void 0 : onChange({
            date: newDate,
            formattedValue: newInputValue,
            localIsoString: localIsoString,
            value: localIsoString.slice(0, 10),
            error: error,
            name: name,
        });
    }, [
        setValue,
        onChange,
        name,
        disableFuture,
        disablePast,
        disableWeekend,
        maxDate,
        minDate,
        shouldDisableDate,
    ]);
    return {
        date: date,
        inputValue: inputValue,
        calendarOpen: calendarOpen,
        setCalendarOpen: setCalendarOpen,
        changeHandler: changeHandler,
    };
}
//# sourceMappingURL=useDatePickerState.js.map